import React, { useEffect } from 'react';
import { QuestionToAsk, PrintPage } from '../../components';
import { AmazonPixelAboutYouSubmitted } from '../../utils/AmazonPixel';

function LmsDeclined({ cardName, declinedReason, data }) {
    const lmsDeclinedStatus = {
        duplicateLead: 'duplicateLead',
        negativePinCode: 'negativePinCode',
        lessIncome: 'lessIncome'
    }
    useEffect(() => {
       /* window.setITag("confirmation", "success");*/
        window.setPageContext("ThankYou");
        AmazonPixelAboutYouSubmitted(data?.selectedProduct)
    }, []);
    return (
        <div className="dls-gray-01-bg">
            <div>
                <div className="stack body">
                    <div className="pad-responsive">
                        <div className="text-align-center pad-1">
                            Thank you for applying for {cardName}.
                        </div>
                        <div className="text-align-center pad-1">
                            {declinedReason === lmsDeclinedStatus.duplicateLead &&
                                <>You have already checked your eligibility for {cardName}. We request you to check again only after three months.</>
                            }
                            {declinedReason === lmsDeclinedStatus.negativePinCode &&
                                <>Based on the details provided by you, we regret to inform you that you are not pre qualified for {cardName} at this point in time. You will shortly receive an email from us with more details on the same</>
                            }
                            {declinedReason === lmsDeclinedStatus.lessIncome &&
                                <>Based on the details provided by you, we regret to inform you that you are not pre qualified for {cardName} at this point in time. You will shortly receive an email from us with more details on the same</>
                            }
                        </div>
                    </div>
                    <div className="pad-4">
                        <PrintPage />
                        <QuestionToAsk />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LmsDeclined;